module.exports = __webpack_public_path__ + "img/Image-new.aedb7df4.svg";